import TableItemComponent from './TableItemComponent';


const TableWrapper = ({ data, marketIdsList, showAction, onSelectionChange }) => {

    return (
        <div className="card shadow mb-4">
            <div className="">
                <div className="table-responsive">
                    <div id="dataTable_wrapper" className="dataTables_wrapper dt-bootstrap4">
                        <div className="">
                            <div className="">
                                <TableItemComponent scheduleData={data} showAction={showAction} onSelectionChange={onSelectionChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableWrapper;
